// BillingSuccess.tsx
import React, { useEffect, useState, useCallback } from "react";
import { CHROME_STORE_URL } from "../constants";

const BillingSuccess: React.FC = () => {
  const [extensionReady, setExtensionReady] = useState(false);
  const [sessionId] = useState<string | null>(() => {
    if (typeof window === "undefined") return null;

    try {
      const params = new URLSearchParams(window.location.search || "");

      return params.get("session_id");
    } catch {
      return null;
    }
  });

  useEffect(() => {
    const onMsg = (ev: MessageEvent) => {
      if (ev.data?.type === "TUBLY_READY") setExtensionReady(true);
    };
    window.addEventListener("message", onMsg);

    // pergunta explicitamente
    window.postMessage({ type: "TUBLY_HELLO" }, "*");

    // re-pergunta por alguns segundos
    const iv = setInterval(() => {
      if (!extensionReady) window.postMessage({ type: "TUBLY_HELLO" }, "*");
    }, 500);
    const to = setTimeout(() => clearInterval(iv), 4000);

    return () => { window.removeEventListener("message", onMsg); clearInterval(iv); clearTimeout(to); };
  }, [extensionReady]);

  const openExtension = useCallback(() => {
    window.postMessage({ type: "TUBLY_OPEN_AFTER_STRIPE", ref: "checkout", sessionId }, "*");
    if (!extensionReady) setTimeout(() => { if (!extensionReady) window.location.href = CHROME_STORE_URL; }, 800);
  }, [extensionReady, sessionId]);

  return (
    <div className="mx-auto max-w-2xl py-24 px-6 text-center">
      <h1 className="text-3xl font-bold text-gray-900">Thank you for subscribing!</h1>
      <p className="mt-4 text-gray-600">
        Your Tubly membership is now active.
      </p>

      <button
        type="button"
        className="mt-10 bg-red-500 text-white font-bold py-3 px-8 rounded-lg text-lg transition-transform hover:bg-red-600 hover:scale-105 shadow-lg cursor-pointer"
        onClick={openExtension}
      >
        Open Tubly Onboarding
      </button>
    </div>
  );
};

export default BillingSuccess;
